import React from 'react';
import BlotterColumnsModal from 'widgets/blotter/BlotterColumnsModal';
import BlotterFiltersModal from 'widgets/blotter/filtersModal/BlotterFiltersModal';
import './BlotterToolbar.scss';
import ColumnPortfolio, {
    BlotterColumn,
} from 'widgets/blotter/columns/ColumnPortfolio';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import {
    Button,
    ColumnDefinitionsDictionary,
} from '@instinet-analytics/semantic-ui-components';
import QuickSearch from 'utils/components/QuickSearch/QuickSearch';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { GridExportButton } from '@instinet-analytics/semantic-ui-components';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

interface BlotterToolbarProps {
    blotterId: string;
    columnPortfolio: ColumnPortfolio;
    columnDefinitions: ColumnDefinitionsDictionary<BlotterColumn>;
    filteredRowCount: number;
    filterApplied: boolean;
    onClearFilter: () => void;
    onSearchChange: (value: string) => void;
    searchText: string;
    height: number;
    gridApi?: GridApi;
}

/**
 * BlotterToolbar
 * Renders a toolbar to interact with a blotter grid
 */
export default function BlotterToolbar(props: BlotterToolbarProps) {
    const {
        blotterId,
        onClearFilter,
        onSearchChange,
        gridApi,
        searchText,
        filterApplied,
        filteredRowCount,
        columnPortfolio,
        columnDefinitions,
    } = props;

    const quickSearchApplied = !!searchText;

    const { editedColumnNames } = useWidgetEditedColumnNames();

    return (
        <div className="BlotterToolbar panel-header">
            <div className="toolbar">
                <QuickSearch
                    filterApplied={filterApplied}
                    filteredRowCount={filteredRowCount}
                    searchText={searchText}
                    onSearchChange={onSearchChange}
                    placeholder={'Search for an order'}
                />
            </div>

            <WidgetToolbar
                preceedingItems={
                    quickSearchApplied ? (
                        <Button
                            className="clear-button"
                            onClick={onClearFilter}
                        >
                            Clear
                        </Button>
                    ) : undefined
                }
                fixedItems={
                    <>
                        <GridExportButton
                            csvFileName="Order Blotter"
                            gridApi={gridApi}
                            editedColumnNames={editedColumnNames}
                        />
                        <BlotterFiltersModal
                            key="filters"
                            columnDefinitions={columnDefinitions}
                            blotterId={blotterId}
                            trigger={
                                <div className="BlotterFiltersModalTrigger">
                                    <ToolbarIcon name="filter" />
                                    {filterApplied && (
                                        <div className="filter-indicator" />
                                    )}
                                </div>
                            }
                        />
                        <BlotterColumnsModal
                            key="columns"
                            blotterId={blotterId}
                            columnPortfolio={columnPortfolio}
                        />
                    </>
                }
            />
        </div>
    );
}
